import { Button } from 'primereact/button';
import React from 'react';
import dayjs from 'dayjs';

import Dialog from '../../../../shared/PFDialog/PFDialogContainer';
import { clientDetails } from '../../../../../constants';

interface LoginConfig {
  remind_in_days: string | number;
}

interface ClientDetails {
  login_configuration: LoginConfig;
}

interface MpinSetupPopupProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const typedClientDetails = clientDetails as ClientDetails;

const MpinSetupPopup: React.FC<MpinSetupPopupProps> = ({
  visible,
  setVisible,
}) => {
  const remindDaysRaw = typedClientDetails?.login_configuration?.remind_in_days;

  const remindDays: number =
    typeof remindDaysRaw === 'string'
      ? parseInt(remindDaysRaw, 10)
      : typeof remindDaysRaw === 'number'
        ? remindDaysRaw
        : 0;

  const setMpinPopUpRemindDate = dayjs()
    .add(remindDays, 'day')
    .toDate()
    .toUTCString();

  const setMpinPopUpRemindDays = remindDays || 7;
  const setMpinPopUpRemindDayText = `Remind me ${setMpinPopUpRemindDays} day(s) later`;

  return (
    <Dialog
      header="Enable PIN Protection"
      visible={visible}
      className="sm:w-5 lg:w-4"
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      pt={{
        headerIcons: {
          className: 'hidden',
        },
      }}
      footer={
        <>
          <Button
            outlined
            label={setMpinPopUpRemindDayText}
            onClick={() => {
              document.cookie = `setMpinPopuptime=${setMpinPopUpRemindDate}; expires=${setMpinPopUpRemindDate}; path=/`;
              setVisible(false);
            }}
            className="m-2"
          />
          <Button
            label="Set up"
            onClick={() => {
              localStorage.setItem('wantSetupMpin', 'yes');
              setVisible(false);
            }}
            className="m-2"
          />
        </>
      }
      draggable={false}
    >
      <p className="m-0">Would you like to set up your PIN?</p>
    </Dialog>
  );
};

export default MpinSetupPopup;
